import { constant, constNull } from "fp-ts/function";

import cx from "classnames";
import {
  Box,
  Children,
  useBreakpoints,
  containerRowMaxWidthG4P as containerRowMaxWidth,
  PaletteColorG4P as PaletteColor,
} from "@dbn/omnichannel-design-system-g4p";
import { headerHeight } from "../headerHeight";
import * as classes from "./Container.css";

type Props = {
  leftContent: Children;
  rightContent: Children;
  leftColor: PaletteColor;
  centerColor: PaletteColor;
  centerContent?: Children;
  rightColor: PaletteColor;
  component?: keyof JSX.IntrinsicElements;
  isHeader?: boolean;
  leftMarginPx?: number;
};

function SideContent({
  content,
  paddingSide,
  color,
}: {
  content?: Children;
  paddingSide: "left" | "right";
  color: PaletteColor;
}) {
  const sidePaddingX = 0;

  const paddingStyle = (() => {
    switch (paddingSide) {
      case "left":
        return {
          paddingLeft: sidePaddingX,
        };
      case "right":
        return {
          paddingRight: sidePaddingX,
        };
    }
  })();
  return (
    <Box
      style={{
        ...paddingStyle,
        backgroundColor: color,
      }}
    >
      {content}
    </Box>
  );
}

function CenterContent({
  centerColor,
  centerContent,
}: {
  centerColor: PaletteColor;
  centerContent?: Children;
}) {
  return (
    <Box basis="100%" grow shrink style={{ backgroundColor: centerColor }}>
      {centerContent}
    </Box>
  );
}

export function ContainerHeader(props: Props) {
  const { foldBreakpoints } = useBreakpoints();
  return (
    <Box
      component={props.component}
      height={headerHeight}
      className={cx({ [classes.topLeftCorner]: props.isHeader })}
      style={{ backgroundColor: props.leftColor, justifyContent: "center" }}
    >
      <Box
        style={{
          width: "100%",
          maxWidth: `min(${containerRowMaxWidth}px, 80%)`,
          marginLeft: props.leftMarginPx ? props.leftMarginPx : undefined,
        }}
      >
        <SideContent
          content={props.leftContent}
          paddingSide="right"
          color={props.leftColor}
        />
        {foldBreakpoints({
          ifDesktopWide: constant(
            <CenterContent
              centerColor={props.centerColor}
              centerContent={props.centerContent}
            />
          ),
          ifDesktop: constant(
            <CenterContent
              centerColor={props.centerColor}
              centerContent={props.centerContent}
            />
          ),
          ifTablet: constant(
            <CenterContent
              centerColor={props.centerColor}
              centerContent={props.centerContent}
            />
          ),
          ifMobileLandscape: constant(
            <CenterContent centerColor={props.centerColor} />
          ),
          ifMobilePortrait: constNull,
        })}
        <SideContent
          content={props.rightContent}
          paddingSide="left"
          color={props.rightColor}
        />
      </Box>
    </Box>
  );
}
